import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
    selector: 'form-domain-scan-login-types-custom-multistep',
    templateUrl: './form-domain-scan-login-custom-multistep.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false,
})
export class FormDomainScanLoginCustomMultistepComponent implements OnInit {
    @Input() login: any = {};

    ngOnInit () {
        if (!this.isObject(this.login.custom_multistep)) {
            this.login.custom_multistep = {
                steps: [''],
                username: '',
                password: '',
                verify: {
                    location: '',
                },
            };
        }
        if (!this.login?.verify?.location) {
            this.login.verify = {
                location: '',
            };
        }
    }

    addStep () {
        this.login.custom_multistep.steps.push('');
    }

    removeStep (index) {
        this.login.custom_multistep.steps.splice(index, 1);
    }

    trackByFn (index: number, item: any): any {
        return index;
    }

    // PROTECTED

    isObject (val) {
        return val !== null && typeof val === 'object';
    }
}
